import { getClientSecret } from 'core-components/sitebuilder/helpers/getClientSecret'
import { getTokens } from 'core-components/sitebuilder/helpers/getTokens'

interface IGlobalIframeData {
  oneTimeToken?: string
  accessToken?: string | null
  refreshToken?: string | null
  clientId?: string | null
  secretId?: string | null
  culture?: string | null
  user?: string
  userEmail?: string
  userCountry?: string
}

interface IGlobalIframeParams {
  ownerId: string
  src?: string
  oneTimeToken?: string
}

export const getGlobalsForIframe = async ({ ownerId, src, oneTimeToken }: IGlobalIframeParams) => {
  const globals: IGlobalIframeData = {}
  if (src) {
    if (src.indexOf('oneTimeToken') > -1) {
      globals.oneTimeToken = oneTimeToken
    }
    if (src.indexOf('token') > -1) {
      const [accessToken] = getTokens(ownerId)
      globals.accessToken = accessToken
    }
    if (src.indexOf('refreshToken') > -1) {
      const [, refreshToken] = getTokens(ownerId)
      globals.refreshToken = refreshToken
    }
    if (src.indexOf('clientId') > -1) {
      const [clientId] = getClientSecret(ownerId)
      globals.clientId = clientId
    }
    if (src.indexOf('secretId') > -1) {
      const [, secretId] = getClientSecret(ownerId)
      globals.secretId = secretId
    }
  }
  return globals
}
